/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule RelayOSSContainerProxy
 * 
 */

'use strict';

/**
 * This feature is deprecated and unavailable in open source.
 */
var RelayOSSContainerProxy = {
  proxyMethods: function proxyMethods(Container, Component) {}
};

module.exports = RelayOSSContainerProxy;


//////////////////
// WEBPACK FOOTER
// ./~/react-relay/lib/RelayOSSContainerProxy.js
// module id = 610
// module chunks = 0